import React, { useState, type Dispatch, type SetStateAction } from "react";

import { operatorOptions } from "@features/creative-analytics/components/ca-creative-type-bar";
import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";
import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

import { useProductAnalyticsContext } from "../hooks";

interface FilterModalProps {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

const columns = [
  { name: "rev", title: "Revenue" },
  { name: "rev_first_time", title: "Rev (1st Time)" },
  { name: "rev_returning", title: "Rev (Returning)" },
  { name: "txns", title: "Orders" },
  { name: "quantity", title: "Units Sold" },
  { name: "cacPercentage", title: "CAC index" },
  { name: "roasPercentage", title: "Roas Index" },
  { name: "proportional_spend", title: "Product Spend" },
  { name: "proas", title: "Product ROAS" },
  { name: "pcac", title: "Product CAC" },
  { name: "aov", title: "AOV" },
  { name: "asp", title: "ASP" },
  { name: "itemSoldRatio", title: "Item Ratio" },
];

const FilterModal = ({ isModalOpen, setIsModalOpen }: FilterModalProps) => {
  const { tableState, setMetricFilters } = useProductAnalyticsContext();
  const [localFilters, setLocalFilters] = useState(tableState.metricFilters);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      titleContent={<h2>Filter</h2>}
    >
      <div className="min-w-[450px]">
        <div className="flex flex-col gap-4 max-w-md mx-auto mt-8">
          {localFilters.map((filter, index) => (
            <div key={index} className="flex gap-3 items-center">
              <Select
                onChange={(value) => {
                  const newFilters = [...localFilters];
                  newFilters[index].id = value;
                  setLocalFilters(newFilters);
                }}
                placeholder="Select Column"
                options={columns.map((col) => ({
                  label: col.title,
                  value: col.name,
                }))}
                value={filter.id}
              />
              <Select
                onChange={(value) => {
                  const newFilters = [...localFilters];
                  newFilters[index].operator = value;
                  setLocalFilters(newFilters);
                }}
                placeholder="Greater Than"
                options={operatorOptions}
                value={filter.operator}
              />
              <div className="w-full">
                <TextInput
                  className="w-full"
                  inputClassName="font-light"
                  placeholder="Filter value"
                  type="number"
                  value={String(filter.value ?? "")}
                  onChange={(e) => {
                    const newFilters = [...localFilters];
                    newFilters[index].value = e.target.value;
                    setLocalFilters(newFilters);
                  }}
                />
              </div>
              <TertiaryButton
                onClick={() => {
                  const newFilters = localFilters.filter((_, i) => i !== index);
                  setLocalFilters(newFilters);
                }}
                className=""
              >
                <i className="fa-regular fa-trash uppercase text-[#F05F33]"></i>
              </TertiaryButton>
            </div>
          ))}
          <TertiaryButton
            className="flex items-center text-primary font-semibold text-sm w-fit"
            onClick={() => {
              setLocalFilters([
                ...localFilters,
                { id: "", operator: "greaterThan", value: 0 },
              ]);
            }}
          >
            <i className="fa-regular fa-sharp fa-filter text-[0.8rem] text-primary mt-0.5 mr-1 w-4" />
            ADD FILTER
          </TertiaryButton>
        </div>
        {/* <div className="overflow-auto max-h-[500px]">
          <div className="overflow-hidden text-ellipsis text-v2-primary mt-4  mb-2 font-semibold text-[12px] uppercase">
            Removed Records
          </div>
          <div className="w-full flex justify-between border-y border-[#E5E5E5]">
            <div className="overflow-hidden text-ellipsis text-v2-primary py-2 text-[12px] uppercase">
              Test Row
            </div>
            <TertiaryButton
              className="flex items-center text-primary font-semibold text-[12px] uppercase"
              onClick={() => {}}
            >
              ADD
            </TertiaryButton>
          </div>
        </div> */}
        <div className="flex justify-between pt-6">
          <TertiaryButton
            onClick={() => setIsModalOpen(false)}
            className="uppercase"
          >
            cancel
          </TertiaryButton>
          <PrimaryButton
            onClick={() => {
              setMetricFilters(localFilters);
              setIsModalOpen(false);
            }}
            className="uppercase"
          >
            Apply Filters
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default FilterModal;
